import { Tabs } from '@mantine/core';
import classNames from 'theme/components/Navigation/Tabs/Tabs.module.css';

export default Tabs.extend({
  classNames,
});
